
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5935DD","d":"M2.54 5.394h14.92v10.737H2.54z"}}),_c('path',{attrs:{"d":"M8.49 1.843h7.97a1 1 0 011 1V4.64H8.49V1.843z","fill":"#E345FF"}})])
          )
        }
      }
    